import { inject, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, map } from 'rxjs';

@Pipe({
  name: 'adminActiveRoute',
})
export class AdminActiveRoutePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return value === args[0] ? 'active' : '';
  }
}
